module.exports = __webpack_public_path__ + "static/media/persona-josh.c629099d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/Onboarding/persona-josh.jpg
// module id = 184
// module chunks = 0